import { Badge } from "reactstrap"

const BadgeList = ({
  items = [], // array of objects
  labelKey = "name", // key to display inside badge
  badgeClass = "badge-soft-info",
  fallback = "-", // what to show if empty/invalid
}) => {
  if (!Array.isArray(items) || items.length === 0) {
    return <span>{fallback}</span>
  }

  return (
    <div className="d-flex flex-wrap gap-1">
      {items.map((item, index) => (
        <Badge key={item?.[labelKey] ?? index} className={badgeClass}>
          {item?.[labelKey] ?? fallback}
        </Badge>
      ))}
    </div>
  )
}

export default BadgeList
